import axios, { AxiosRequestConfig } from 'axios'
import defaultsDeep from 'lodash/defaultsDeep'
import qs from 'qs'
import { FREIGHT_API_URL } from 'core/common/constants/env'
import { onResponseError, onResponseSuccess, setHeaders } from './interceptors'

export const paramsSerializer = (params: unknown) => qs.stringify(params, { arrayFormat: 'repeat' })

const baseURL = FREIGHT_API_URL

const getConfig = () => ({
  paramsSerializer,
})

const freightApi = axios.create({
  baseURL,
  withCredentials: false,
  validateStatus: status => (status >= 200 && status < 300) || status === 304,
})

freightApi.interceptors.response.use(onResponseSuccess, onResponseError)

freightApi.interceptors.request.use((config: AxiosRequestConfig) => {
  const mergedConfig = defaultsDeep(config, getConfig())

  return setHeaders(mergedConfig)
}, onResponseError)

export default freightApi
